module.exports = __webpack_public_path__ + "a09f363aeb86534ce099e876b11e9751.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/pages/HomePage2/PrintTypes/screenprint.jpg
// module id = 868
// module chunks = 1